<template>
  <div v-if="Object.keys(groupedButtons).length" :style="buttonContext && buttonContext == 'Asset'?'gap:1px':'gap:5px;'" class="configured-buttons-main-wrapper" style="display:flex">
    <div
      v-for="(group, groupId) in groupedButtons"
      :key="groupId"
      class="d-inline-block mr-1 dynamic-configured-buttons-wrapper"
    >
      <!-- Case 1: Single button -->
      <button
        v-if="group.length === 1"
        class="btn"
        type="button"
        :class="[buttonClass(group[0]), noBorder ? 'default-button-styles': '',{
          'configured-button-disabled':
            isButtonDisabled(group[0])
        }]"
        :style="[buttonStyle(group[0]), noBorder ? {padding:'0px'} : {}, customizeStyles]"
        @click="onButtonClick(group[0])"
        :title="
          isButtonDisabled(group[0])
            ? getButtonTitle(group[0])
            : group[0].button_name">
        <img 
          v-if="group[0].button_image" 
          :src="getProxyConvertedURL(group[0].button_image)" 
          :style="imageStyles?imageStyles:''"
          alt="btn image" 
          class="btn-image"
        />
        <i v-else-if="group[0].button_icon" :class="['bi','bi-'+group[0].button_icon]"></i>
        <span v-if="group[0].display_button_name">{{ group[0].button_name }}</span>      
      </button>

      <!-- Case 2: Grouped buttons -->
      <div v-else class="btn-group dropup">
        <!-- Primary button -->
        <button
          class="btn"
          type="button"
          :class="[buttonClass(primaryBtn(group)),{'configured-button-disabled':isButtonDisabled(primaryBtn(group))}]"
          :style="[buttonStyle(primaryBtn(group)), customizeStyles]"
          @click="onButtonClick(primaryBtn(group))"
          :title="isButtonDisabled(primaryBtn(group))
          ? getButtonTitle(primaryBtn(group))
          : primaryBtn(group).button_name">
        <img 
          v-if="primaryBtn(group).button_image" 
          :src="getProxyConvertedURL(primaryBtn(group).button_image)" 
          :style="imageStyles?imageStyles:''"
          alt="btn image" 
          class="btn-image"
        />
          <i v-else-if="primaryBtn(group).button_icon" :class="['bi','bi-'+primaryBtn(group).button_icon]"></i>
          <span v-if="primaryBtn(group).display_button_name">{{ primaryBtn(group).button_name }}</span>      
        </button>

        <!-- Dropdown toggle with manual caret -->
        <button
          class="btn"
          type="button"
          :class="[buttonClass(primaryBtn(group)),{'configured-button-disabled':isButtonDisabled(primaryBtn(group))}]"
          :style="[buttonStyle(primaryBtn(group)), customizeStyles]"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :title="isButtonDisabled(primaryBtn(group))
          ? getButtonTitle(primaryBtn(group))
          : primaryBtn(group).button_name">
          <!-- manual caret arrow -->
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>
          </span>
        </button>

        <!-- Dropdown menu -->
        <div class="dropdown-menu" :class="enableDropUp?'show-dropdown-up':'dropdown-styles'">
          <a
            v-for="btn in secondaryBtns(group)"
            :key="btn._id"
            class="dropdown-item"
            :class="{
              'configured-button-disabled':
                isButtonDisabled(btn)
            }"
            :style="[buttonStyle(btn), customizeStyles]"
            @click.prevent="onButtonClick(btn)"
            :title="isButtonDisabled(btn) ? getButtonTitle(btn) : btn.button_name">
            <img 
              v-if="btn.button_image" 
              :src="getProxyConvertedURL(btn.button_image)" 
              :style="imageStyles?imageStyles:''"
              alt="btn image" 
              class="btn-image"
            />
            <i v-if="btn.button_icon" :class="['bi','bi-'+btn.button_icon]"></i>
            <span v-if="btn.display_button_name">{{ btn.button_name }}</span>      
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import {mapMutations,mapGetters} from "vuex";
  import Utils from "../../components.utils.js";

  export default {
    name: "ButtonsGroup",
    props: ['componentId','buttons','noBorder', 'customizeStyles','enableDropUp',"sendThisIdBack","buttonContext", "imageStyles", "ruleData", "disableAfterClick"],
    data() {
      return {
        localButtons: Array.isArray(this.buttons) ? [...this.buttons] : [], // reactive local copy
        clickedButtonIds: []
      };
    },
    watch: {
      buttons: {
        handler(newVal) {
          this.localButtons = Array.isArray(newVal) ? [...newVal] : [];
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters("users", ["getLoggedInUserPrivilege","getLoggedInUserType"]),
      groupedButtons() {
        const groups = {};

        this.localButtons
          .filter(btn => this.shouldShowButton(btn))
          .forEach(btn => {
            const key = btn.group_id || btn._id;

            if (!groups[key]) {
              groups[key] = [];
            }

            groups[key].push(btn);
          });

        return groups;
      },
    },
    beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
    },
    created() {
      this.registerforWebsocketNotifications();
    },
    methods: {
      ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
      getButtonPrivileges(button) {
        try {
          const rule = typeof button?.action_rule === "string" ? button.action_rule : "";

          const oldMatch = rule.match(/PRIVILEGES\s*:\s*\[([^\]]*)\]/i);
          if (oldMatch) {
            return oldMatch[1].split(",").map(p => p.replace(/['"\s]/g, "")).filter(Boolean);
          }

          const privileges = [...rule.matchAll(/USER\.PRIVILEGES\s*==\s*["']([^"']+)["']/gi)];
          return privileges.map(match => match[1].trim()).filter(Boolean);

        } catch (error) {
          console.error("[getButtonPrivileges]", error);
          return [];
        }
      },

      hasButtonPrivilege(button) {
        try {
          const privileges = this.getButtonPrivileges(button);
          if (!privileges.length) return true;

          return privileges.every(privilege => {
            if (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privilege)) return true;

            const availablePrivileges = Array.isArray(this.getLoggedInUserPrivilege)
              ? this.getLoggedInUserPrivilege
              : [];

            const matchedPrivilege = availablePrivileges.find(
              item => String(item).toLowerCase() === privilege.toLowerCase()
            );

            return matchedPrivilege
              ? Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, matchedPrivilege)
              : false;
          });
        } catch (error) {
          console.error("[hasButtonPrivilege]", error);
          return true;
        }
      },

      shouldShowButton(button) {
        if (!button || typeof button !== "object") return false;
        return this.isAdministrator() || this.hasButtonPrivilege(button);
      },

      checkButtonCondition(button) {
        try {
          const rule = typeof button?.action_rule === "string"
            ? button.action_rule
            : "";

          // Example:
          // IF (USER.PRIVILEGES=="Archive"&&ASSET.ARCHIVED==FALSE{BUTTON.ENABLE=TRUE;...};
          const match = rule.match(
            /IF\s*\((.*?)\)\s*\{([\s\S]*?)\}\s*;?/i
          );

          // No IF condition - existing behaviour
          if (!match) return true;

          // No data passed - don't break existing components
          if (!this.ruleData || typeof this.ruleData !== "object") {
            return true;
          }

          const conditionMatched = this.evaluateConditions(match[1]);

          const enableMatch = match[2].match(
            /BUTTON\.ENABLE\s*=\s*(TRUE|FALSE)/i
          );

          if (!enableMatch) return true;

          const enable = enableMatch[1].toLowerCase() === "true";

          return conditionMatched ? enable : !enable;

        } catch (error) {
          console.error("[checkButtonCondition]", error);
          return true;
        }
      },

      getRuleValue(value) {
        value = String(value).trim().replace(/^['"]|['"]$/g, "");

        if (/^true$/i.test(value)) return true;
        if (/^false$/i.test(value)) return false;
        if (/^null$/i.test(value)) return null;
        if (/^-?\d+(\.\d+)?$/.test(value)) return Number(value);

        return value;
      },

      getRuleFieldValue(path) {
        if (!path || typeof path !== "string") {
          return false;
        }

        const parts = path
          .trim()
          .split(".")
          .filter(Boolean);

        if (!parts.length) {
          return false;
        }

        const context = parts.shift().toUpperCase();

        // Handle logged-in user fields
        if (context === "USER") {
          if (
            parts.length === 1 &&
            parts[0].toUpperCase() === "PRIVILEGES"
          ) {
            return this.getLoggedInUserPrivilege || [];
          }

          return false;
        }

        // Find the value from ruleData using case-insensitive keys
        const fieldValue = parts.reduce((currentValue, key) => {
          if (
            currentValue === null ||
            currentValue === undefined ||
            typeof currentValue !== "object"
          ) {
            return undefined;
          }

          const actualKey = Object.keys(currentValue).find(
            item => item.toLowerCase() === key.toLowerCase()
          );

          if (actualKey === undefined) {
            return undefined;
          }

          return currentValue[actualKey];
        }, this.ruleData);

        // Generic fallback for any missing field
        return fieldValue === undefined ? false : fieldValue;
      },

      compareRuleValue(actual, expected) {
        if (Array.isArray(actual)) {
          return actual.some(value =>
            String(value).toLowerCase() === String(expected).toLowerCase()
          );
        }

        if (
          typeof actual === "string" &&
          typeof expected === "string"
        ) {
          return actual.toLowerCase() === expected.toLowerCase();
        }

        return actual === expected;
      },

      evaluateCondition(condition) {
        const match = condition.match(
          /^\s*([\w.]+)\s*==\s*(.+?)\s*$/
        );

        if (!match) return false;

        const actual = this.getRuleFieldValue(match[1]);
        const expected = this.getRuleValue(match[2]);

        return this.compareRuleValue(actual, expected);
      },

      evaluateConditions(conditionString) {
        return conditionString
          .split("&&")
          .every(condition =>
            this.evaluateCondition(condition.trim())
          );
      },

      isButtonDisabled(button) {
        if (!button || typeof button !== "object") return true;

        const privilegeDisabled =
          this.isAdministrator() && !this.hasButtonPrivilege(button);

        const clickedDisabled =
          this.disableAfterClick && this.clickedButtonIds.includes(button._id);

        return privilegeDisabled || !this.checkButtonCondition(button) || clickedDisabled;
      },

      isAdministrator() {
        try {
          return Utils.isUserTypeAdmin(this.getLoggedInUserType);
        } catch (error) {
          console.error("[isAdministrator]", error);
          return false;
        }
      },
      primaryBtn(group) {
        if (!Array.isArray(group) || !group.length) return {};
        return group.find(button => button?.position === "Primary") || group[0];
      },
      secondaryBtns(group) {
        return Array.isArray(group)
        ? group.filter(button => button?.position === "Secondary")
        : [];
      },
      buttonStyle(btn) {
        if (!btn) return {};

        if (btn.button_color) {
          const baseColor = btn.button_color;
          const textColor = btn.fill_background_color ? "#fff" : baseColor;

          return {
            backgroundColor: btn.fill_background_color ? baseColor : "transparent",
            color: textColor,
            border: this.noBorder ? "none" : `1px solid ${baseColor}`,
          };
        }

        return this.noBorder ? { border: "none" } : {};
      },
      buttonClass(btn) {
        return !btn.button_color && !this.noBorder
          ? "btn-outline-secondary change-border"
          : "";
      },
      getButtonTitle(button) {
        if (this.isAdministrator() && !this.hasButtonPrivilege(button)) {
          return this.$t("You do not have privilege to perform this action");
        }

        if (this.disableAfterClick && this.clickedButtonIds.includes(button?._id)) {
          return this.$t("Action already triggered");
        }

        if (!this.checkButtonCondition(button)) {
          return this.$t("This action is not available for the current asset");
        }

        return button?.button_name || "";
      },
      onButtonClick(button) {
        if (this.isButtonDisabled(button)) {
          return;
        }

        const buttonInfo = {
          componentId: this.componentId,
          buttonInfo: button
        };

        if (this.sendThisIdBack) {
          buttonInfo.returnableID =
            this.sendThisIdBack;
        }

        // Only wire up the disable-after-click callback when that behaviour is requested.
        // The button is disabled ONLY if the listener reports success (calls onComplete(true)).
        // On failure (onComplete(false) or the listener not calling it at all), the button stays enabled so the user can retry.
        if (this.disableAfterClick && button?._id) {
          buttonInfo.onComplete = (success) => {
            if (success && !this.clickedButtonIds.includes(button._id)) {
              this.clickedButtonIds.push(button._id);
            }
          };
        }

        this.$emit("button-click", buttonInfo);
      },
      handleConfiguredButtons(notification){
        try {
          notification =
            notification?.detail && Object.keys(notification.detail).length
              ? notification.detail
              : notification;

          const messageInfo = notification?.message;

          if (
            notification?.message_type !== "COMPONENT_BUTTONS_UPDATED" ||
            !messageInfo ||
            messageInfo.component_id !== this.componentId
          ) {
            return;
          }

          this.localButtons = Array.isArray(messageInfo.buttons_info)
            ? [...messageInfo.buttons_info]
            : [];
        } catch (error) {
          console.error("[handleConfiguredButtons]", error);
        }
      },
      registerforWebsocketNotifications(){
            this.addWSEventListener({
            eventname:["COMPONENT_BUTTONS_UPDATED"],
            callback:this.handleConfiguredButtons,
            parent: "ConfiguredButtons"});
      },
      
      unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
            eventname:["COMPONENT_BUTTONS_UPDATED"],
            callback:this.handleConfiguredButtons,
            parent: "ConfiguredButtons"});
      },
    },
  };
  </script>

<style lang="scss" scoped>

$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$tags-border-color:#363636;
$panel-heading-font-size:18px;
$secondary-border-color: 1px solid #2b2b2b;

.change-border{
    border: $border-color !important;
}

.default-button-styles{
    color: $secondary-text-color;
}

.default-button-styles:hover{
    color: $text-color !important;
}

.dropdown-menu{
  background-color:$secondary-background-color !important;
  border: $border-color;
  padding:0px;
  .dropdown-item{
    color:$text-color;
    font-size:14px !important; 
    word-break: break-word;
    height: 38px;
    display: flex;
    align-items: anchor-center;
    gap: 7px;
    border-radius: 5px;
  }
}

.btn-image {
width: 25px;
height: 25px;
object-fit: cover;   // ensures 1:1 ratio without distortion
border-radius: 4px;  // optional (if you want rounded edges)
}

.dropdown-item:hover{
background-color:$bg-color-on-hover !important;
}

.btn-group{
position: relative;
.dropdown-menu {
  inset-inline-start: 0 !important;       /* align with left edge */
  inset-inline-end: auto !important;
  transform: none !important;
  margin-top: 2px;  
}
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {
border-top-right-radius: 4px;
border-bottom-right-radius: 4px;
}

.show-dropdown-up{
top: -55px !important;
}

.dropdown-styles{
top: 100% !important;
}

.btn{
gap:7px;
display:flex;
}

.configured-button-disabled {
opacity: 0.45;
cursor: not-allowed !important;
filter: grayscale(1);
}

a.configured-button-disabled {
pointer-events: auto;
}

a.configured-button-disabled:hover {
background-color: transparent !important;
}
</style>